import * as ko from "knockout";
import Bao from "./../../services/bao-service";
function ReminderModuleViewModel(parent) {
    var self = this;
    self.parent = parent;
    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.DashboardUrl = ko.observable();
    self.ReminderTypes = ko.observableArray([]);
    self.ReminderTypeId = ko.observable();
    self.FilterTypes = ko.observableArray([]);
    self.Filter = ko.observable();
    self.ReminderCollection = ko.observableArray([]);
    self.TotalRows = ko.observable(0);
    self.PageSize = ko.observable(20);
    self.PageIndex = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.SelectedRow = ko.observable({});
    self.IsLoading = ko.observable(false);
    self.SelectRow = function (item) {
        self.SelectedRow(item);
        return true;
    };
    self.DisplayTotalRows = ko.computed(function () {
        if (self.TotalRows() <= self.PageSize()) {
            return self.TotalRows();
        }
        else {
            return self.PageSize() + " / " + self.TotalRows();
        }
    });
    self.PageIndex.subscribe(function () {
        self.Load();
    });

    self.PageSize.subscribe(function () {
        self.PageIndex(0);
        self.Load();
    });

    self.Sorting.subscribe(function () {
        self.Load();
    });
    self.Filter.subscribe(function (item) {
        self.DashboardUrl("");
        $.each(self.FilterTypes(), function (index, row) {
            if (row.Key == item) {
                self.DashboardUrl(row.OpenUrl);
            }
        });
        self.Load();
    });
    self.ReminderTypeId.subscribe(function () {
        self.Load();
    });
    self.Load = function () {
        var def = $.Deferred();
        self.IsLoading(true);
        if (self.Initialized()) {
            Bao.post("SynosetStartModule/GetReminders", JSON.stringify({
                reminderTypeId: self.ReminderTypeId(),
                filter: self.Filter(),
                pageIndex: self.PageIndex(),
                pageSize: self.PageSize(),
                sorting: self.Sorting()
            }), function (searchResult) {
                self.SelectedRow(null);
                self.TotalRows(0);
                self.ReminderCollection([]);
                if (searchResult != null && searchResult.Models != null) {
                    self.ReminderCollection(searchResult.Models);
                    self.TotalRows(searchResult.TotalRows);
                }
                def.resolve();
                self.IsLoading(false);
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    self.parent.Refresh = function () {
        self.Load();
    };
    self.init = function () {
        var def = $.Deferred();
        $.when(Bao.post("SynosetStartModule/GetReminderTypes", JSON.stringify({}), function (searchResult) {
            self.ReminderTypes([]);
            if (searchResult != null) {
                self.ReminderTypes(searchResult);
                if (self.parent != null && self.parent.Parameter() != null) {
                    var parameter = self.parent.Parameter().split(";");
                    if (parameter.length > 0) {
                        self.ReminderTypeId(parameter[0]);
                    }
                }
            }
        }), Bao.post("SynosetStartModule/GetReminderFilter", JSON.stringify({}), function (searchResult) {
            self.FilterTypes([]);
            if (searchResult != null) {
                self.FilterTypes(searchResult);
                if (self.parent != null && self.parent.Parameter() != null) {
                    var parameter = self.parent.Parameter().split(";");
                    if (parameter.length > 1) {
                        self.Filter(parameter[1]);
                    }
                }
            }
        })).then(function () {
            self.Initialized(true);
            def.resolve();
        });
        return def.promise();
    };
    self.loaded = function () {
        return self.Load();
    };
}
export default ReminderModuleViewModel;